import { EstadoEpisodio } from 'types/models';

export const ESTADO_META: Record<
  EstadoEpisodio,
  { label: string; colorScheme: string; dot: string }
> = {
  [EstadoEpisodio.ABIERTO]:        { label: 'Abierto',        colorScheme: 'blue',   dot: '#63B3ED' },
  [EstadoEpisodio.EN_TRATAMIENTO]: { label: 'En Tratamiento', colorScheme: 'orange', dot: '#F6AD55' },
  [EstadoEpisodio.CERRADO]:        { label: 'Cerrado',        colorScheme: 'green',  dot: '#68D391' },
  [EstadoEpisodio.ARCHIVADO]:      { label: 'Archivado',      colorScheme: 'gray',   dot: '#A0AEC0' },
};

export function formatFecha(d: string): string {
  const [y, m, day] = d.split('-');
  return `${day}/${m}/${y}`;
}
